import { createApp } from 'vue'
import { createPinia } from 'pinia' 
import { useUserStore } from './store/userStore';
import App from './App.vue'
import router from './router'
import AppLayout from './components/appLayout.vue';
import ElementPlus from 'element-plus'; // 全局引入 Element Plus
import 'element-plus/dist/index.css'; // 全局引入样式
import './assets/css/font.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'; // 引入所有图标

const app = createApp(App)

const pinia = createPinia();
app.use(pinia);

app.component('appLayout', AppLayout)
app.use(ElementPlus); // 注册 Element Plus
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

const userStore = useUserStore();
userStore.initAuth();

app.use(router)
app.mount('#app')